var processInclude = require('./util');

$(document).ready(function () {
    if (!window.ApplePaySession || !window.ApplePaySession.canMakePayments()) {
        $('.js-apple-pay-container').remove();
    }
    var name = 'lastPage=';
    var lastPage = '';
    var cookieArray = document.cookie.split(';');
    for (var i = 0; i < cookieArray.length; i++) {
        var cookieItem = cookieArray[i];
        if (cookieItem.indexOf(name) !== -1) {
            lastPage = cookieItem.substring(name.length + 1, cookieItem.length);
        }
    }
    if (lastPage === '' || document.URL !== lastPage) {
        document.cookie = 'orderID' + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        document.cookie = 'orderEmail' + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        document.cookie = 'lastPage' + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
    processInclude(require('./components/clientSideValidation'));
    processInclude(require('./components/footer'));
    processInclude(require('./components/collapsibleItem'));
    processInclude(require('./components/search'));
    processInclude(require('./components/accessibility'));
    processInclude(require('./components/menuNav'));
    processInclude(require('./components/countdown'));
    processInclude(require('./components/locale'));
    processInclude(require('./components/analytics'));
    processInclude(require('./wishlist/wishlist'));
    var $phoneHeader = $('.js-phone-header');
    var $phoneHeaderMobile = $('.js-phone-header-tab-mob');
    var url = $phoneHeader.data('url');
    $.ajax({
        url: url,
        type: 'get',
        success: function (data) {
            if (data.enableInThisCountry) {
                $phoneHeader.removeClass('d-none');
                $phoneHeaderMobile.removeClass('d-none');
                $phoneHeader.find('.cc-text').text(data.label);
                $phoneHeaderMobile.find('.cc-text').text(data.label);

                var phoneHeaderElement = $('.js-phone-header');
                var dataAccessibilityValue = phoneHeaderElement.attr('data-accessibility');

                $phoneHeader.find('.cc-icon').attr('aria-label', dataAccessibilityValue+ " " + data.label);
                $phoneHeaderMobile.find('.cc-icon').attr('aria-label', dataAccessibilityValue+ " " + data.label);
                
                $('.js-phone-header-tab-mob').attr('href', 'tel:' + data.value);
            } else {
                $phoneHeader.hide();
                $phoneHeaderMobile.hide();
                $('.js-phone-row').remove();
            }
        },
        error: function () {
            $phoneHeader.hide();
            $phoneHeaderMobile.hide();
            $('.js-phone-row').remove();
        }
    });
    if ($(document).find('.js-update-cartItemNumber').length) {
        var cartItemNumberUrl = $(document).find('.js-update-cartItemNumber').val();
        $.ajax({
            url: cartItemNumberUrl,
            type: 'get',
            success: function (data) {
                if (data) {
                    var loginObject = $('.login.lazyload');
                    var visitorObject = $('.visitorId.lazyload');
                    var cartItemObject = $('.cartItemNumber.lazyload');
                    loginObject.text(data.isLogged);
                    visitorObject.text(data.userUUID);
                    cartItemObject.text(data.cartItemNumber);
                    loginObject.removeClass('lazyload');
                    visitorObject.removeClass('lazyload');
                    cartItemObject.removeClass('lazyload');
                    $('body').trigger('analytics:pushuserdatachange');
                }
            },
            error: function () {

            }
        });
    }
    var $deliveryTime = $('.js-delivery-time');
    if ($deliveryTime.length > 0) {
        var urlDelivery = $deliveryTime.data('url');
        $.ajax({
            url: urlDelivery,
            type: 'get',
            success: function (data) {
                if (data.minDays && data.maxDays) {
                    $('.js-delivery-min-days').text(data.minDays);
                    $('.js-delivery-max-days').text(data.maxDays);
                }
            },
            error: function () { }
        });
    }

    // Full page cache: load minicart quantity ajax
    if ($('.minicart[data-minicartajax-url]').length > 0) {
        $.post($('.minicart[data-minicartajax-url]').eq(0).data('minicartajax-url'), {}, function(data) {
            $('.minicart', '.cc-section-right').each(function() {
                $(this).html(data);
            });
        });
    }
    // Full page cache: load minicart content ajax and init Paypal
    if ($('#cart-placeholder').length) {
        $.post($('#cart-placeholder').eq(0).data('cartajax-url'), {}, function(data) {
            $('#cart-placeholder').each(function() {
                $(data).insertAfter(this);
                $(this).remove();
                processInclude(require('./components/miniCartSide'));
            });
        });
    }

    // Full page cache: load shipping banner content via ajax
    if ($('#banner-placeholder').length) {
        $.post($('#banner-placeholder').eq(0).data('bannerajax-url'), {}, function(data) {
            $('#banner-placeholder').each(function() {
                $(data).insertAfter(this);
                $(this).remove();

                var isVisible = $('.js-locale-switch-popup').attr('data-isvisible');
                if (isVisible === 'true'){
                    var geolocationountry = $('.js-locale-switch-popup').attr('data-whereami');
                    $('body').trigger('analytics:pushgeolocationbanner', {eventCategory: 'checklocale', eventAction: 'start', eventLabel: geolocationountry});
                }
            });
        });
    }
});

if ($(document).find('.cc-full-page-dashboard').length > 0 || $(document).find('.js-ContactUs-Page').length > 0 || $(document).find('.js-Return-page').length > 0 || $(document).find('.js-appointment').length > 0) {
    processInclude(require('./common/datepicker'));
}

// common should be processed first to enable window settings
require('./common/common');

var cntrlIsPressed = false;

$(document).keydown(function(event) {
    if (event.which == '17') {
        cntrlIsPressed = true;
    }
    if (event.metaKey) {
        cntrlIsPressed = true;
    }
});

$(document).keyup(function() {
    cntrlIsPressed = false;
});

$('body').on('click', '*[href]', function(e) {
    var targetBlank = false;
    targetBlank = $(this).attr('target') ? $(this).attr('target') === '_blank' : false;
    if ($(this)[0].classList.value.indexOf('cc-social') === -1 && $(this)[0].classList.value.indexOf('js') === -1 && $(this).attr('href').indexOf('#') === -1 && !cntrlIsPressed && !targetBlank && $(this).attr('href').indexOf('javascript:void(0)') === -1) {
        $.spinner().start();
    }
});
